"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Always takes a given value and returns a function that will return that value when invoked.
 *
 * @example
 * import always from '@carvana/futilities/always';
 * const fn = always('blue')
 * fn()
 * // () => 'blue'
 *
 */
function always(val) {
    return function () { return val; };
}
exports.default = always;
//# sourceMappingURL=always.js.map